export const getCroppedImg = (imageSrc, crop) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = 468;
      canvas.height = 60;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(
        image,
        crop.x,
        crop.y,
        crop.width,
        crop.height,
        0,
        0,
        468,
        60
      );

      canvas.toBlob((blob) => {
        if (!blob) {
          return reject(new Error("Canvas is empty"));
        }
        resolve(blob);
      }, "image/jpeg");
    };
    image.onerror = reject;
  });
};
